import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { FC } from 'react';
import Image from 'next/image';
import { useDarkMode, useMediaUp } from '../../../../hooks';

interface TwoColumnsProps {
  title: string;
  subtitle: string;
  list: Array<{ boldText: string; text: string }>;
  image: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: theme.spacing(10, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(15, 0),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(13.5, 0),
    },
  },
  item: {
    position: 'relative',
  },
  gpmTitle: {
    color: (isDarkMode) => (isDarkMode ? theme.palette.common.white : '#2A2A36'),
    fontSize: 35,
    lineHeight: '35px',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      fontSize: 50,
      lineHeight: '50px',
    },
  },
  subtitle: {
    color: (isDarkMode) => (isDarkMode ? theme.palette.common.white : '#0A1524'),
    fontSize: 15,
    fontWeight: 400,
    maxWidth: '100%',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      maxWidth: 628,
    },
  },
  boldText: {
    color: (isDarkMode) => (isDarkMode ? theme.palette.common.white : '#0A1524'),
    fontSize: 15,
    fontWeight: 500,
  },
  liItem: {
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: 586,
    },
  },
}));

const TwoColumns: FC<TwoColumnsProps> = (props) => {
  const { title, subtitle, list, image } = props;
  const { isDarkMode } = useDarkMode();
  const classes = useStyles(isDarkMode);
  const mediaUp = useMediaUp('md');

  return (
    <Container maxWidth={false} fixed>
      <Grid className={classes.content} justifyContent="space-between" alignItems={'center'} container spacing={mediaUp ? 8 : 4}>
        <Grid className={classes.item} md={6} xs={12} style={{ order: mediaUp ? 1 : 2 }} item>
          <Typography className={classes.gpmTitle}>{title}</Typography>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
          <ul className={classes.liItem}>
            {list.map((item, index) => (
              <li key={index}>
                <Typography className={classes.boldText}>
                  {item.boldText} - <span style={{ fontWeight: 300 }}>{item.text}</span>
                </Typography>
              </li>
            ))}
          </ul>
        </Grid>
        <Grid md={6} xs={12} style={{ order: mediaUp ? 2 : 1 }} item>
          <Box mt={mediaUp ? -10 : -5}>
            <Image src={image} height={550} width={625} />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TwoColumns;
